import React from 'react';

import PersonTeaser from './Teaser';
import NotFound from '../../../containers/NotFound';

const NodePerson = (props) => {
  const { viewMode } = props;
  if (viewMode === 'teaser') {
    return <PersonTeaser {...props} />;
  }

  return <NotFound />;
};

export default NodePerson;
